import { getCurrentTime } from "./time_util"

export interface ObjectPoolItem<T> {
    data: T
    free: boolean
}

export abstract class ObjectPool<T> {
    items: ObjectPoolItem<T>[] = []
    ptr: number = -1
    releasing: boolean

    constructor(size: number = 1000) {
        this.grow(size)
    }

    abstract create(): ObjectPoolItem<T>

    abstract clear(item: ObjectPoolItem<T>): void

    private grow = (size: number = 1000) => {
        for (let i = 0; i < size; i++) {
            this.items.push(this.create())
        }
    }

    checkout = (): ObjectPoolItem<T> => {
        if (this.releasing) {
            alert("BAD!")
        }
        this.ptr++
        if (this.ptr > this.items.length - 1) {
            // grow the array
            this.grow(1000)
        }
        const item = this.items[this.ptr]
        item.free = false
        return item
    }

    releaseAll = (visitor?: (item: ObjectPoolItem<T>) => void): number => {
        let count = 0
        this.releasing = true
        const now = getCurrentTime()
        // Release the whole stack down to AND INCLUDING index 0. The old bound `this.ptr > 0`
        // (together with release()'s `ptr < 0 -> 0` clamp) left items[0] permanently checked out:
        // it was never removed from its parent nor handed back out, leaving a stale "ghost" sprite
        // on the surface plus a one-slot leak per pool.
        while (this.ptr >= 0 && getCurrentTime() - now < 2000) {
            const toRelease = this.items[this.ptr]
            if (toRelease.free) {
                // Defensive: release() no-ops on an already-free item without moving ptr, which
                // would spin forever here. Step past it manually.
                this.ptr--
                continue
            }
            if (visitor) {
                visitor(toRelease)
            }
            this.release(toRelease)
            count++
        }

        this.ptr = -1
        this.releasing = false
        return count
    }

    release = (item: ObjectPoolItem<T>) => {
        if (item.free) {
            // already free, noop
            return
        }

        item.free = true
        this.clear(item)

        this.ptr--
        if (this.ptr < 0) {
            this.ptr = 0
        }
    }
}
